import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ModalService } from 'src/app/shared/services/modal.service';
import { StepsComponent } from 'src/app/shared/components/steps/steps.component';
import { IUnidade } from 'src/app/shared/interfaces/unidade/iunidade';
import { Store, select } from '@ngrx/store';
import { IUnidadeState } from 'src/app/store/unidade/unidade.reducer';
import { editUnidade, loadUnidade, saveUnidade } from 'src/app/store/unidade/unidade.actions';
import { IUnitTaxInfo } from 'src/app/shared/interfaces/unidade/iunittaxinfo';
import { UnidadeService } from 'src/app/shared/services/unidade.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { PostalCodeService } from 'src/app/shared/services/postal-code.service';
import { NotifyService } from 'src/app/shared/services/notify.service';
import { CustomValidator } from 'src/app/shared/validators/custom-validator';
import { selectBankLista } from 'src/app/store/bank/bank.selectors';
import { loadBank } from 'src/app/store/bank/bank.actions';
import { selecPostUnitError, selectCurrentUnit, selectUnitState } from 'src/app/store/unidade/unidade.selectors';
import { UploadService } from 'src/app/shared/services/upload.service';
import { ClientService } from 'src/app/shared/services/client.service';
import { OcupationAreaService } from '../service/ocupation-area.service';
import { selectProfessionLista } from 'src/app/store/profession/profession.selectors';
import { loadProfession } from 'src/app/store/profession/profession.actions';
@Component({
  selector: 'app-unidade-form',
  templateUrl: './unidade-form.component.html',
  styleUrls: ['./unidade-form.component.scss'],
})

export class UnidadeFormComponent implements OnInit, AfterViewInit {
  
  @ViewChild('steps') steps!: StepsComponent
  dragdropMessage: string = 'Arraste aqui o arquivo ".pfx"'
  certificateFile: File | null = null
  isStepDisabled = false;
  stateList = this.postalCodeService.states
  selectedCity!: string
  citiesListPJ: any
  citiesListPF: any
  bancoLista$ = this.store.select(selectBankLista);
  bankList!: any[]
  isLoadingCities: boolean = false;
  errIbge: boolean = false
  activeIndex: number = 0
  clientId = localStorage.getItem('clientId')
  unitState$ = this.store.select(selectUnitState)
  currentUnit$ = this.store.select(selectCurrentUnit)
  ProfessionList$ = this.store.select(selectProfessionLista);
  selecPostUnitError$ = this.store.select(selecPostUnitError)
  currentId: any
  form = this.formBuilder.group({
    //id: [null],
    selfDeclaredLegalRepresentative: [false, Validators.requiredTrue],
    occupationArea: [null, Validators.required],
    clientId: [null],
    isActive: [true],
    contactNumber: ['', [Validators.required, Validators.minLength(10)]],
    contactNumberCell: ['', [Validators.required, Validators.minLength(9)]],
    contactNumberTell: ['', [Validators.required, Validators.minLength(8)]],
    isCellphone: [true, Validators.required],
    isTelephone: [false, Validators.required],
    ddd: ['', [Validators.required, Validators.minLength(2)]],
    unitName: ['', [Validators.required]],
    annual_revenue: [null as any, Validators.required],
    registrationNumber: ['', [Validators.required, Validators.minLength(14), CustomValidator.validateCNPJ()]],

    representative: this.formBuilder.group({
      id: [null],
      name: ['', [Validators.required]],
      profession: [''],
      monthlyIncome: [null as any, [Validators.required]],
      taxId: ['', [Validators.required, CustomValidator.validateTaxId()]],
      birthdate: ['', [Validators.required, CustomValidator.validateDate()]],
      representativeEmail: ['', [Validators.required, Validators.email]],
      contactNumber: ['', [Validators.required, Validators.minLength(10)]],
      address: this.formBuilder.group({
        postalCode: ['', [Validators.required, CustomValidator.validateCep()]],
        state: [null as any, [Validators.required]],
        city: [null as any, [Validators.required]],
        streetAddress: ['', [Validators.required]],
        district: ['', [Validators.required]],
        number: [null as any, [Validators.required]],
        address2: [''],
        country: ['Brasil'],
        ibge: [null as any],
        localidade: [null as any]
      })
    }),
    openingDate: [''],
    industry: [''],
    country: [''],
    website: [''],
    additionalDetails: [''],
    address: this.formBuilder.group({
      postalCode: ['', [Validators.required, CustomValidator.validateCep()]],
      country: ['Brasil'],
      state: [null as any, [Validators.required]],
      city: [null as any, [Validators.required]],
      district: ['', [Validators.required]],
      streetAddress: ['', [Validators.required]],
      number: [null as any, [Validators.required]],
      address2: [''],
      ibge: [null as any],
      localidade: [null as any]
    }),
    main: [false],
    reviewLink: [''],
    flagIssuesInvoice: [false],
    flagUsesHeadOfficeTaxData: [false],
    contactEmail: ['', [Validators.required, Validators.email]],
    taxInfo: this.formBuilder.group({
      digitalCertificationFile: [''],
      issuerPartnerId: [''],
      tradeName: ['', [Validators.required]],
      legalName: ['', [Validators.required]],
      bank: [null as any, [Validators.required]],
      digit: ['', [Validators.required]],
      bankBranch: ['', [Validators.required]],
      checkingAccount: ['', [Validators.required]],
      taxRegime: [null as any, [Validators.required]],
      specialRegime: [null as any, [Validators.required]],
      taxRegimeCode: [null as any],
      stateRegistration: [''],
      municipalRegistration: ['', [Validators.required]],
      issRate: [null as any],
      //serviceCode: ['0', [Validators.required]],
      // digitalCertificationPassword: [''],
      // digitalCertificationFile: [null as any],
    })
  })
  isUploadLoading: boolean = false
  uploadCertificateForm = this.formBuilder.group({
    password: ['', [Validators.required]],
    partnerId: ['', [Validators.required]]
  })
  isLoadingUnit: boolean = false
  response: any
  unitId = null

  formatNumberBank(bank: any) {
    return bank ? ("00" + bank?.code)?.slice(-3) + " - " + bank?.name : "";
  }

  get certificateFormValidation() {
    const isCertificateInvalid: boolean = this.certificateFile != null ? false : true

    return isCertificateInvalid ||
      this.uploadCertificateForm.controls.password.invalid
  }

  get firstStepValidation() {
    const form = this.form.controls
    if (!this.form.value.flagIssuesInvoice) {
      return form.unitName.invalid ||
        form.contactNumber.invalid ||
        form.contactEmail.invalid ||
        form.registrationNumber.invalid
    } else if (this.form.value.flagIssuesInvoice && !this.form.value.flagUsesHeadOfficeTaxData) {
      let isFormInvalid: boolean = form.unitName.invalid ||
        form.contactNumber.invalid ||
        form.occupationArea.invalid ||
        form.annual_revenue.invalid ||
        form.contactEmail.invalid ||
        form.registrationNumber.invalid ||
        form.taxInfo.controls.legalName.invalid ||
        form.taxInfo.controls.tradeName.invalid ||
        form.taxInfo.controls.taxRegime.invalid ||
        form.taxInfo.controls.specialRegime.invalid ||
        form.taxInfo.controls.municipalRegistration.invalid

      if (this.form.value.main) {
        return isFormInvalid ||
          form.taxInfo.controls.bank.invalid ||
          form.taxInfo.controls.bankBranch.invalid ||
          form.taxInfo.controls.checkingAccount.invalid ||
          form.taxInfo.controls.digit.invalid
      } else {
        return isFormInvalid
      }



    } else if (this.form.value.flagIssuesInvoice && !this.form.value.main && this.form.value.flagUsesHeadOfficeTaxData) {
      return form.unitName.invalid ||
        form.contactNumber.invalid ||
        form.address.invalid

    }
    return null
  }

  get secondStepValidation() {
    return this.form.controls.address.invalid
  }

  get tirdStepValidation() {
    return this.form.controls.representative.invalid ||
      this.form.controls.selfDeclaredLegalRepresentative.invalid
  }

  constructor(
    private formBuilder: FormBuilder,
    public modalService: ModalService,
    private store: Store<IUnidadeState>,
    private service: UnidadeService,
    private postalCodeService: PostalCodeService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private notify: NotifyService,
    private cd: ChangeDetectorRef,
    private uploadService: UploadService,
    private occupationService: OcupationAreaService
  ) { }

  get occupationAreaFormControl(): FormControl {
    return <FormControl>this.form.get('occupationArea');
  }

  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }

  ngOnInit(): void {

    this.selecPostUnitError$.subscribe(res => {
      if (res?.id) {
        this.currentId = res.id
      }
    })

    this.store.dispatch(loadProfession())

    this.unitState$.subscribe(res => {
      //console.log('unit state: ', res)
      if(res.type == "success" && res.action != "get"){

        if(this.form.value.flagIssuesInvoice == false){
          this.ref.close();
        }

        if(this.form.value.flagIssuesInvoice == true){

          if(this.form.value.flagUsesHeadOfficeTaxData == true){
            return this.ref.close();
          }
          
          this.activeIndex = 3;
          this.onActiveIndexChanged(3);

        }
      }
      if(res.type == "error" && res.action != "get"){

        if(this.form.value.flagIssuesInvoice == false){
          this.activeIndex = 1;
          this.onActiveIndexChanged(1);
        }

        if(this.form.value.flagIssuesInvoice == true){

          if(this.form.value.flagUsesHeadOfficeTaxData == true){
            this.activeIndex = 0;
            this.onActiveIndexChanged(0);
            return
          }
          
          this.activeIndex = 2;
          this.onActiveIndexChanged(2);

        }
      }
      
    })

    this.currentUnit$.subscribe(res => {
      if (res != null) {

        const parterId = res.taxInfo?.issuerPartnerId
        this.uploadCertificateForm.controls.partnerId.setValue(parterId)

        console.log('currentUnit: ', res)

        this.unitId = res.id
      }

    })

    //this.clearAllFormValidations()
    this.formatBankFromAPI()
    // if (!this.config.data?.id) {
    //   this.setFormValidations(true, false, false)
    // }
    this.store.dispatch(loadBank());
    if (this.config.data?.id) {
      this.currentId = this.config.data?.id
      const data = this.config.data
      //console.log('dados: ', data)
      let account: any = null;
      let digit: any = null;

      if (data?.taxInfo) {
        [account, digit] = data?.taxInfo?.bankAccount?.checkingAccount.split("-");
      }
      this.loadCitiesByUF(data.address?.state, true)
      this.loadCitiesByUF(data.representative?.address?.state, false)


      this.form.patchValue({
        clientId: data.client,
        isActive: data.isActive,
        contactNumber: data.contactNumber,
        unitName: data.unitName,
        registrationNumber: data.registrationNumber,
        annual_revenue: data.annualRevenue,
        representative: data.representative ? ({
          name: data.representative.name,
          birthdate: this.formatDateForm(data.representative.birthdate),
          taxId: data.representative.taxId,
          profession: data.representative.profession,
          monthlyIncome: data.representative.monthlyIncomeManager,
          // gender: data.representative.gender,
          // identificationNumber: data.representative.identificationNumber,
          // pronoun: data.representative.pronoun,
          // nameMon: data.representative.nameMon,
          contactNumber: data.representative.contactNumber,
          representativeEmail: data.representative.emailProfessional,
          address: data?.representative?.address ? ({
            postalCode: data?.representative?.address.postalCode,
            country: data?.representative?.address.country,
            state: data?.representative?.address.state,
            city: Number(data?.representative?.address.ibge),
            district: data?.representative?.address.neighborhood,
            streetAddress: data?.representative?.address.streetAddress,
            number: data?.representative?.address.number,
            address2: data?.representative?.address.address2,
            ibge: data?.representative?.address.ibge,
            localidade: data?.representative?.address.city
          }) : undefined,
        }) : undefined,
        occupationArea: data.occupationArea ? data.occupationArea['@id'] : '',
        openingDate: data.openingDate,
        industry: data.industry,
        country: data.country,
        website: data.website,
        additionalDetails: data.additionalDetails,
        address: data.address ? ({
          postalCode: data.address.postalCode,
          country: data.address.country,
          state: data.address.state,
          city: Number(data.address.ibge),
          district: data.address.neighborhood,
          streetAddress: data.address.streetAddress,
          number: data.address.number,
          address2: data.address.address2,
          ibge: data.address.ibge,
          localidade: data.address.city
        }) : undefined,
        main: data.main,
        reviewLink: data.reviewLink,
        flagIssuesInvoice: data.flagIssueInvoice,
        flagUsesHeadOfficeTaxData: data.flagUsesHeadOfficeTaxData,
        contactEmail: data.contactEmail,
        taxInfo: ({
          digitalCertificationFile: data?.taxInfo?.digitalCertificationFile,
          tradeName: data.tradeName,
          legalName: data.legalName,
          bank: data?.taxInfo?.bankAccount?.bank['@id'],
          bankBranch: data?.taxInfo?.bankAccount?.bankBranch,
          issuerPartnerId: data?.taxInfo?.issuerPartnerId,
          checkingAccount: account,
          digit: digit,
          taxRegime: data?.taxInfo?.taxRegime,
          taxRegimeCode: data?.taxInfo?.taxRegimeCode,
          specialRegime: data?.taxInfo?.specialRegime,
          stateRegistration: data?.taxInfo?.stateRegistration,
          municipalRegistration: data?.taxInfo?.municipalRegistration,
          issRate: data?.taxInfo?.issRate,
          //serviceCode: data?.taxInfo?.serviceCode,
          //digitalCertificationPassword: data?.taxInfo?.digitalCertificationPassword,
          //digitalCertificationFile: data?.taxInfo?.digitalCertificationFile,
        })

      })
      //this.setFormValidations(true, false, false);
      this.disableSteps();
    }
    this.occupationService.getAll().subscribe((res: any) => {
      this.occupationAreaList = res['hydra:member'];
    });
  }

  formatDateForm(date: string) {

    // "2003-01-20"
    let dateArray = date.split('-')
    let day = dateArray[2]
    let month = dateArray[1]
    let year = dateArray[0]

    const formattedDateForm = `${day}${month}${year}`;

    return formattedDateForm
  }

  setFile(event: any, isRemoving?: boolean) {

    if (isRemoving) {
      this.dragdropMessage = 'Arraste aqui o arquivo ".pfx"'
      this.certificateFile = null
    } else {
      this.dragdropMessage = ''
      this.certificateFile = event.currentFiles[0] as File

    }

  }

  OnUpload() {

    //console.log('form certificate: ', this.uploadCertificateForm.value)
    const file = this.certificateFile as File
    const password = this.uploadCertificateForm.value.password as string
    const partnerId = this.uploadCertificateForm.value.partnerId as string
    this.isUploadLoading = true
    this.uploadService.post(file, password, partnerId).subscribe({
      next: (res: any) => {
        //console.log('sucesso: ', res),
        this.isUploadLoading = false
        this.notify.emitSuccess('Certificado carregado com sucesso!')
        this.ref.close()
      },
      error: (err: any) => {
        this.isUploadLoading = false
        
        this.dragdropMessage = this.certificateFile?.name as string
        console.log('error: ', err)
        this.notify.emitWarn('Verifique o Certificado Digital e a Senha')
      }
    })
  }

  OnSubmit() {
    const form = this.form.value;
    const representative = this.form.value.representative;
    const address = this.form.value.address;
    const taxInfo = this.form.value.taxInfo;

    const addressPJ = {
      postalCode: form.address?.postalCode as string,
      streetAddress: form.address?.streetAddress as string,
      country: form.address?.country as string,
      number: String(form.address?.number),
      address2: form.address?.address2 as string,
      neighborhood: form.address?.district as string,
      city: form.address?.localidade,
      ibge: String(form.address?.ibge),
      state: form.address?.state,
    }

    let taxInfoPJReq: any = {
      taxRegime: taxInfo?.taxRegime,
      specialRegime: taxInfo?.specialRegime,
      stateRegistration: taxInfo?.stateRegistration as string,
      municipalRegistration: taxInfo?.municipalRegistration as string,
      issRate: taxInfo?.issRate?.toString() as string,
      
      //issuerPartnerId: taxInfo?.issuerPartnerId as string
    }

    if(this.form.value.main){
      taxInfoPJReq = {
        ...taxInfoPJReq,
        bankAccount: {
          bank: taxInfo?.bank,
          bankBranch: taxInfo?.bankBranch as string,
          checkingAccount: taxInfo?.checkingAccount + '-' + taxInfo?.digit,
        }
      }
    }

    const representativeReq = {
      name: representative?.name as string,
      //profession: representative?.profession,
      monthlyIncomeManager: representative?.monthlyIncome,
      taxId: representative?.taxId as string,
      birthdate: this.formatReqDate(representative?.birthdate as string),
      emailProfessional: representative?.representativeEmail as string,
      contactNumber: representative?.contactNumber as string,
      address: {
        postalCode: representative?.address?.postalCode as string,
        streetAddress: representative?.address?.streetAddress as string,
        country: representative?.address?.country as string,
        number: String(representative?.address?.number),
        address2: representative?.address?.address2 as string,
        neighborhood: representative?.address?.district as string,
        city: representative?.address?.localidade,
        ibge: String(representative?.address?.ibge),
        state: representative?.address?.state,
      }
    }

    let req: any = {
      isActive: true,
      secret: 'teste',
      main: form.main as boolean,
      flagIssueInvoice: form.flagIssuesInvoice as boolean,
      flagUsesHeadOfficeTaxData: form.flagUsesHeadOfficeTaxData as boolean,
      client: `/api/clients/${this.clientId}`,
      unitName: form.unitName as string,
      contactNumber: form.contactNumber as string,
      contactEmail: form.contactEmail as string,
      registrationNumber: form.registrationNumber as string,
      address: addressPJ
    }



    if (form.flagIssuesInvoice && !form.flagUsesHeadOfficeTaxData) {
      req = {
        ...req,
        legalName: taxInfo?.legalName as string,
        tradeName: taxInfo?.tradeName as string,
        occupationArea: form.occupationArea,
        annualRevenue: form.annual_revenue,
        taxInfo: taxInfoPJReq,
        representative: representativeReq
      }
    } else if (form.flagIssuesInvoice && form.flagUsesHeadOfficeTaxData) {
      req = {
        isActive: true,
        secret: 'teste',
        main: form.main as boolean,
        flagIssueInvoice: form.flagIssuesInvoice as boolean,
        flagUsesHeadOfficeTaxData: form.flagUsesHeadOfficeTaxData as boolean,
        client: `/api/clients/${this.clientId}`,
        unitName: form.unitName as string,
        contactNumber: form.contactNumber as string,
        contactEmail: form.contactEmail as string,
        registrationNumber: form.registrationNumber,
        address: addressPJ
      }
    }

    if (this.currentId) {

      return this.store.dispatch(editUnidade({ unidade: req, id: this.currentId }))
    } else {
      return this.store.dispatch(saveUnidade({ unidade: req }))
    }

    // const taxInfoPJReq = {
    //   taxRegime: taxInfo?.taxRegime?.name,
    //   specialRegime: taxInfo?.specialRegime,
    //   stateRegistration: taxInfo?.stateRegistration as string,
    //   municipalRegistration: taxInfo?.municipalRegistration as string,
    //   issRate: taxInfo?.issRate?.toString() as string,
    //   bankAccount: {
    //     bank: taxInfo?.bank,
    //     bankBranch: taxInfo?.bankBranch as string,
    //     checkingAccount: taxInfo?.checkingAccount + '-' + taxInfo?.digit,
    //   }
    //   //issuerPartnerId: taxInfo?.issuerPartnerId as string
    // }

    // let addressNumber = String(this.form.value.address?.number)


    // const bankAccount = {
    //   bank: taxInfo?.bank,
    //   bankBranch: taxInfo?.bankBranch as string,
    //   checkingAccount: taxInfo?.checkingAccount + '-' + taxInfo?.digit,
    //   //digit: taxInfo?.digit as string
    // }

    // let req: IUnidade | any = {
    //   occupationArea: form.occupationArea,
    //   isActive: form.isActive as boolean,
    //   secret: 'teste',
    //   client: `/api/clients/${this.clientId}`,
    //   legalName: taxInfo?.legalName as string || form.unitName as string,
    //   tradeName: taxInfo?.tradeName as string,
    //   unitName: form.unitName as string,
    //   registrationNumber: form.registrationNumber as string,
    //   representative: this.areAllFieldsEmpty(representative) ? null : {
    //     name: representative?.name as string,
    //     birthdate: representative?.birthdate ? representative?.birthdate as string : '2020-01-01',
    //     taxId: representative?.taxId as string,
    //     contactNumber: representative?.contactNumber as string,
    //     contactEmail: representative?.representativeEmail as string,
    //     address: null
    //   },
    //   openingDate: form.openingDate ? form.openingDate as string : null,
    //   industry: form.industry as string,
    //   website: form.website as string,
    //   additionalDetails: form.additionalDetails as string,
    //   address: this.areAllFieldsEmpty(address) ? null : {
    //     postalCode: address?.postalCode as string,
    //     country: address?.country as string,
    //     state: address?.state,
    //     city: this.selectedCity,
    //     district: address?.district as string,
    //     streetAddress: address?.streetAddress as string,
    //     number: addressNumber,
    //     address2: address?.address2 as string
    //   },
    //   contactNumber: form.contactNumber as string,
    //   main: form.main as boolean,
    //   reviewLink: form.reviewLink as string,
    //   flagIssueInvoice: form.flagIssuesInvoice as boolean,
    //   flagUsesHeadOfficeTaxData: form.flagUsesHeadOfficeTaxData as boolean,
    //   contactEmail: form.contactEmail as string,
    //   taxInfo: this.areAllFieldsEmpty(taxInfoReq) ? null : {
    //     bankAccount: this.areAllFieldsEmpty(bankAccount) ? null : {
    //       bank: taxInfo?.bank,
    //       bankBranch: taxInfo?.bankBranch as string,
    //       checkingAccount: `${taxInfo?.checkingAccount}-${taxInfo?.digit}` as string,
    //     },
    //     legalStructure: "/api/legal_structures/1",
    //     taxRegime: taxInfo?.taxRegime,
    //     taxRegimeCode: null,
    //     specialRegime: taxInfo?.specialRegime,
    //     stateRegistration: taxInfo?.stateRegistration as string,
    //     municipalRegistration: taxInfo?.municipalRegistration as string,
    //     issRate: taxInfo?.issRate?.toString() as string,
    //     //serviceCode: taxInfo?.serviceCode as string,
    //     issuerPartnerId: taxInfo?.issuerPartnerId ? taxInfo?.issuerPartnerId : '',
    //     //digitalCertificationPassword: taxInfo?.digitalCertificationPassword as string,
    //     //digitalCertificationFile: taxInfo?.digitalCertificationFile as string,
    //     representativeEmail: representative?.representativeEmail as string
    //   }
    // }

  }

  formatReqDate(date: string) {
    let year = date?.substring(4, 8);
    let month = date?.substring(2, 4);
    let day = date?.substring(0, 2);

    const formattedDate = `${year}-${month}-${day}`;

    return formattedDate

  }

  onChangeSplitNF() {

    this.resetFlagUsesHeadOfficeTaxData()

    //this.form.get('flagUsesHeadOfficeTaxData')?.setValue(Boolean(this.form.value.flagIssuesInvoice));


    //this.setFormValidations(true, false, false)

    if (!this.form.value.flagIssuesInvoice) {
      this.resetTaxInfo()
      this.resetRepresentative()
      this.form.controls.reviewLink.reset()

    }
    this.disableSteps();

  }
  disableSteps() {
    //this.isStepDisabled = !Boolean(this.form.value.main) && Boolean(this.form.value.flagIssuesInvoice);
  }

  onChangeDadosFiscaisMatriz() {

    //this.setFormValidations(true, false, false)



    this.resetRepresentative()
    this.resetTaxInfo()
    this.form.controls.reviewLink.reset()

  }

  // onChangeState(UF: any, cityID?: string) {
  //   this.isLoadingCities = true
  //   this.errIbge = false;

  //   if (!UF || UF == '') {

  //     this.form.patchValue({
  //       address: ({
  //         city: null as any
  //       })
  //     })

  //     this.isLoadingCities = false
  //     return this.citiesList = null
  //   }

  //   return this.postalCodeService.getCitiesByState(UF).subscribe({
  //     next: (res: any) => {
  //       this.citiesList = res

  //       if (cityID) {

  //         let id = Number(cityID)
  //         this.form.patchValue({
  //           address: ({
  //             city: id
  //           })
  //         })

  //       }

  //       this.isLoadingCities = false
  //       this.errIbge = false;
  //     },
  //     error: (err: any) => {
  //       this.notify.emitWarn('Erro ao consultar cidades no serviço parceiro .');
  //       this.isLoadingCities = false;
  //       this.errIbge = true;
  //     }

  //   })
  // }

  clearAllFormValidations() {
    const representative = this.form.get('representative')
    const address = this.form.get('address')
    const taxInfo = this.form.get('taxInfo')

    this.form.get('unitName')?.clearValidators();
    this.form.get('contactNumber')?.clearValidators();
    this.form.get('registrationNumber')?.clearValidators();
    this.form.get('openingDate')?.clearValidators();
    this.form.get('industry')?.clearValidators();
    this.form.get('country')?.clearValidators();
    this.form.get('website')?.clearValidators();
    this.form.get('additionalDetails')?.clearValidators();
    this.form.get('main')?.clearValidators();
    this.form.get('reviewLink')?.clearValidators();
    this.form.get('flagIssuesInvoice')?.clearValidators();
    this.form.get('flagUsesHeadOfficeTaxData')?.clearValidators();
    this.form.get('contactEmail')?.clearValidators();

    representative?.get('name')?.clearValidators()
    representative?.get('birthdate')?.clearValidators()
    representative?.get('taxId')?.clearValidators()
    representative?.get('gender')?.clearValidators()
    representative?.get('identificationNumber')?.clearValidators()
    representative?.get('pronoun')?.clearValidators()
    representative?.get('nameMon')?.clearValidators()
    representative?.get('contactNumber')?.clearValidators()
    representative?.get('address')?.clearValidators()
    representative?.get('representativeEmail')?.clearValidators()

    address?.get('postalCode')?.clearValidators()
    address?.get('country')?.clearValidators()
    address?.get('state')?.clearValidators()
    address?.get('city')?.clearValidators()
    address?.get('district')?.clearValidators()
    address?.get('streetAddress')?.clearValidators()
    address?.get('number')?.clearValidators()
    address?.get('address2')?.clearValidators()

    taxInfo?.get('tradeName')?.clearValidators()
    taxInfo?.get('legalName')?.clearValidators()
    taxInfo?.get('bank')?.clearValidators()
    taxInfo?.get('bankBranch')?.clearValidators()
    taxInfo?.get('checkingAccount')?.clearValidators()
    taxInfo?.get('taxRegime')?.clearValidators()
    taxInfo?.get('specialRegime')?.clearValidators()
    taxInfo?.get('taxRegimeCode')?.clearValidators()
    taxInfo?.get('stateRegistration')?.clearValidators()
    taxInfo?.get('municipalRegistration')?.clearValidators()
    taxInfo?.get('issRate')?.clearValidators()
    taxInfo?.get('serviceCode')?.clearValidators()
    taxInfo?.get('digitalCertificationPassword')?.clearValidators()
    taxInfo?.get('digitalCertificationFile')?.clearValidators()
    taxInfo?.get('digit')?.clearValidators()


  }

  updateAndValidityForm() {
    const representative = this.form.get('representative')
    const address = this.form.get('address')
    const taxInfo = this.form.get('taxInfo')

    this.form.get('unitName')?.updateValueAndValidity()
    this.form.get('contactNumber')?.updateValueAndValidity()
    this.form.get('registrationNumber')?.updateValueAndValidity()
    this.form.get('openingDate')?.updateValueAndValidity()
    this.form.get('industry')?.updateValueAndValidity()
    this.form.get('country')?.updateValueAndValidity()
    this.form.get('website')?.updateValueAndValidity()
    this.form.get('additionalDetails')?.updateValueAndValidity()
    this.form.get('main')?.updateValueAndValidity()
    this.form.get('reviewLink')?.updateValueAndValidity()
    this.form.get('flagIssuesInvoice')?.updateValueAndValidity()
    this.form.get('flagUsesHeadOfficeTaxData')?.updateValueAndValidity()
    this.form.get('contactEmail')?.updateValueAndValidity()

    representative?.get('name')?.updateValueAndValidity()
    representative?.get('birthdate')?.updateValueAndValidity()
    representative?.get('taxId')?.updateValueAndValidity()
    representative?.get('gender')?.updateValueAndValidity()
    representative?.get('identificationNumber')?.updateValueAndValidity()
    representative?.get('pronoun')?.updateValueAndValidity()
    representative?.get('nameMon')?.updateValueAndValidity()
    representative?.get('contactNumber')?.updateValueAndValidity()
    representative?.get('address')?.updateValueAndValidity()
    representative?.get('representativeEmail')?.updateValueAndValidity()

    address?.get('postalCode')?.updateValueAndValidity()
    address?.get('country')?.updateValueAndValidity()
    address?.get('state')?.updateValueAndValidity()
    address?.get('city')?.updateValueAndValidity()
    address?.get('district')?.updateValueAndValidity()
    address?.get('streetAddress')?.updateValueAndValidity()
    address?.get('number')?.updateValueAndValidity()
    address?.get('address2')?.updateValueAndValidity()

    taxInfo?.get('tradeName')?.updateValueAndValidity()
    taxInfo?.get('legalName')?.updateValueAndValidity()
    taxInfo?.get('bank')?.updateValueAndValidity()
    taxInfo?.get('bankBranch')?.updateValueAndValidity()
    //taxInfo?.get('checkingAccount')?.updateValueAndValidity()
    taxInfo?.get('taxRegime')?.updateValueAndValidity()
    taxInfo?.get('specialRegime')?.updateValueAndValidity()
    taxInfo?.get('taxRegimeCode')?.updateValueAndValidity()
    taxInfo?.get('stateRegistration')?.updateValueAndValidity()
    taxInfo?.get('municipalRegistration')?.updateValueAndValidity()
    taxInfo?.get('issRate')?.updateValueAndValidity()
    taxInfo?.get('serviceCode')?.updateValueAndValidity()
    //taxInfo?.get('digitalCertificationPassword')?.updateValueAndValidity()
    //taxInfo?.get('digitalCertificationFile')?.updateValueAndValidity()
    taxInfo?.get('municipalRegistration')?.updateValueAndValidity()
  }

  // setFormValidations(step0?: boolean, step1?: boolean, step2?: boolean) {
  //   const taxInfo = this.form.get('taxInfo');
  //   const representative = this.form.get('representative');
  //   const address = this.form.get('address');

  //   if (!this.form.value.flagIssuesInvoice) {
  //     if (step0) {
  //       this.clearAllFormValidations()

  //       this.form.get('unitName')?.setValidators(Validators.required)
  //       this.form.get('contactNumber')?.setValidators([Validators.required, Validators.minLength(10)])
  //       this.form.get('contactEmail')?.setValidators([Validators.required, Validators.email])
  //       this.form.get('registrationNumber')?.setValidators([Validators.required, Validators.minLength(14)])
  //     }

  //     if (step1) {
  //       this.clearAllFormValidations()

  //       address?.get('postalCode')?.setValidators(CustomValidator.validateCep())
  //       address?.get('state')?.setValidators(Validators.required)
  //       address?.get('city')?.setValidators(Validators.required)
  //       address?.get('district')?.setValidators(Validators.required)
  //       address?.get('streetAddress')?.setValidators(Validators.required)
  //       address?.get('number')?.setValidators(Validators.required)
  //     }
  //     this.updateAndValidityForm();
  //     return
  //   }

  //   if (this.form.value.flagIssuesInvoice && this.form.value.main) {

  //     if (step0) {

  //       this.clearAllFormValidations()

  //       this.form.get('unitName')?.setValidators(Validators.required)
  //       this.form.get('contactNumber')?.setValidators([Validators.required, Validators.minLength(10)])
  //       this.form.get('contactEmail')?.setValidators([Validators.required, Validators.email])
  //       this.form.get('registrationNumber')?.setValidators([Validators.required, Validators.minLength(14)])

  //       taxInfo?.get('legalName')?.setValidators(Validators.required)
  //       taxInfo?.get('taxRegime')?.setValidators(Validators.required)
  //       taxInfo?.get('specialRegime')?.setValidators(Validators.required)
  //       taxInfo?.get('municipalRegistration')?.setValidators(Validators.required)
  //       taxInfo?.get('serviceCode')?.setValidators(Validators.required)

  //       taxInfo?.get('bank')?.setValidators(Validators.required)

  //       taxInfo?.get('bankBranch')?.setValidators(Validators.required)
  //       taxInfo?.get('digit')?.setValidators(Validators.required)
  //       //taxInfo?.get('digitalCertificationPassword')?.setValidators(Validators.required)

  //       /*
  //      taxInfo?.get('checkingAccount')?.setValidators(Validators.required)

  //  */

  //       //taxInfo?.get('digitalCertificationFile')?.setValidators(Validators.required)
  //     }

  //     if (step1) {

  //       this.clearAllFormValidations()
  //       address?.get('postalCode')?.setValidators(CustomValidator.validateCep())
  //       address?.get('state')?.setValidators(Validators.required)
  //       address?.get('city')?.setValidators(Validators.required)
  //       address?.get('district')?.setValidators(Validators.required)
  //       address?.get('streetAddress')?.setValidators(Validators.required)
  //       address?.get('number')?.setValidators(Validators.required)

  //     }

  //     if (step2) {

  //       this.clearAllFormValidations()
  //       representative?.get('name')?.setValidators(Validators.required)
  //       representative?.get('taxId')?.setValidators([Validators.required, CustomValidator.validateTaxId()])
  //       representative?.get('representativeEmail')?.setValidators([Validators.required, Validators.email])
  //       representative?.get('contactNumber')?.setValidators([Validators.required, Validators.minLength(10)])

  //     }
  //     this.updateAndValidityForm()
  //     return;
  //   }

  //   if (this.form.value.flagIssuesInvoice && !this.form.value.main) {

  //     this.clearAllFormValidations()

  //     this.form.get('unitName')?.setValidators(Validators.required)
  //     this.form.get('contactNumber')?.setValidators([Validators.required, Validators.minLength(10)])
  //     address?.get('postalCode')?.setValidators(CustomValidator.validateCep())
  //     address?.get('state')?.setValidators(Validators.required)
  //     address?.get('city')?.setValidators(Validators.required)
  //     address?.get('district')?.setValidators(Validators.required)
  //     address?.get('streetAddress')?.setValidators(Validators.required)
  //     address?.get('number')?.setValidators(Validators.required)

  //     this.updateAndValidityForm();
  //     return;

  //   }


  //   //this.resetForm()
  // }

  resetTaxInfo() {
    this.form.controls.taxInfo.reset()
  }

  resetRepresentative() {
    this.form.controls.representative.reset()
  }

  resetFlagUsesHeadOfficeTaxData() {
    this.form.patchValue({ flagUsesHeadOfficeTaxData: false })
  }

  validateChar(event: KeyboardEvent) {
    const regex = /^[a-zA-ZáàâãéèêíïóôõöúçñÁÀÂÃÉÈÊÍÏÓÔÕÖÚÇÑ\s]+$/;

    const key = event.key;

    if (!regex.test(key)) {
      event.preventDefault();
    }
  }

  // fillAddress(cep: any) {
  //   cep = cep.replace(/\D/g, '');

  //   this.postalCodeService.getPostalCode(cep).subscribe({
  //     next: (res) => {

  //       this.onChangeState(res.uf, res.ibge)

  //       this.form.patchValue({
  //         address: ({
  //           //postalCode: res.cep,
  //           country: 'Brasil',
  //           state: res.uf,
  //           district: res.bairro,
  //           streetAddress: res.logradouro
  //         })
  //       })

  //     },
  //     //error: (error) => console.log(error)
  //   })
  // }

  onActiveIndexChanged(index: number): void {

    if(index == 3){
      this.isLoadingUnit = true
      //console.log('chegou no 3 agora,', 3)
      let count = 0
      
      this.response = setInterval(() => {
        
        this.service.getById(Number(this.unitId)).subscribe((res: any) => {
          //console.log('response: ', res)
          if(res.taxInfo?.issuerPartnerId?.length > 0){
            let partnerId = res.taxInfo?.issuerPartnerId
            this.uploadCertificateForm.controls.partnerId.setValue(partnerId)
            this.isLoadingUnit = false
            clearInterval(this.response);
          }

        })

        count++
        if(count > 15) {
          clearInterval(this.response)
          this.isLoadingUnit = false
        }
      }, 2000)
    }

    if (this.modalService.action == 'cadastrar') {
      switch (index) {
        case 0:
          this.modalService.changeHeader('Cadastro de Unidade');
          break;
        case 1:
          this.modalService.changeHeader('Endereço da Unidade');
          break;
        case 2:
          this.modalService.changeHeader('Sócio Administrador');
          break;
        case 3:
          this.modalService.changeHeader('Carregar Certificado Digital');
          break;
      }
    } else if (this.modalService.action == 'editar') {
      switch (index) {
        case 0:
          this.modalService.changeHeader('Editar Unidade');
          break;
        case 1:
          this.modalService.changeHeader('Editar Endereço');
          break;
        case 2:
          this.modalService.changeHeader('Editar Sócio Administrador');
          break;
        case 3:
          this.modalService.changeHeader('Editar Certificado Digital');
          break;
      }
    }

    // switch (index) {
    //   case 0:
    //     this.setFormValidations(true, false, false)
    //     break;
    //   case 1:
    //     this.setFormValidations(false, true, false)
    //     break;
    //   case 2:
    //     this.setFormValidations(false, false, true)
    //     break;
    //   default:
    //     break;
    // }

  }
  formatBankFromAPI() {

    this.bancoLista$.subscribe(
      res => {
        this.bankList = res.map((bank) => {
          return {
            ...bank,
            code: String(bank.code).padStart(3, '0')
          }

        })
      }
    )
  }

  autoCompleteAddress(cep: string, objectReference: string | null) {
    cep = cep.replace(/\D/g, '');

    this.postalCodeService.getPostalCode(cep).subscribe({
      next: (res: any) => {

        if (objectReference) {
          this.form.get(objectReference)?.get('address')?.patchValue({
            state: res.uf,
            district: res.bairro,
            streetAddress: res.logradouro,
            city: res.ibge ? Number(res.ibge) : null,
            ibge: res.ibge ? Number(res.ibge) : null,
            localidade: res.localidade,
            country: 'Brasil',
            postalCode: cep,
            number: null,
            address2: null
          })

          this.loadCitiesByUF(res.uf)
        } else {
          this.form.get('address')?.patchValue({
            state: res.uf as string,
            district: res.bairro as string,
            streetAddress: res.logradouro as string,
            city: res.ibge ? Number(res.ibge) : null,
            ibge: res.ibge ? Number(res.ibge) : null,
            localidade: res.localidade,
            country: 'Brasil',
            postalCode: cep,
            number: null,
            address2: null
          })

          this.loadCitiesByUF(res.uf, true)
        }

      }
    })
  }

  loadCitiesByUF(uf: string, changePJAddress: boolean = false) {
    this.postalCodeService.getCitiesByState(uf).subscribe({
      next: (res: any[]) => {
        if (changePJAddress) {
          this.citiesListPJ = res
        }
        this.citiesListPF = res;
      }
    })

  }
  /* dados mocados para o dropdown */



  tiposRegimeTributario = [
    {
      "@id": "/api/tax_regimes/1",
      "@type": "TaxRegime",
      "id": 1,
      "name": "Simples Nacional"
    },
    {
      "@id": "/api/tax_regimes/2",
      "@type": "TaxRegime",
      "id": 2,
      "name": "Lucro Presumido"
    },
    {
      "@id": "/api/tax_regimes/3",
      "@type": "TaxRegime",
      "id": 3,
      "name": "Lucro Real"
    }
  ];

  tiposRegimeEspecial = [
    {
      "@id": "/api/special_regimes/1",
      "@type": "SpecialRegime",
      "id": 1,
      "name": "Sem regime especial"
    },
    {
      "@id": "/api/special_regimes/2",
      "@type": "SpecialRegime",
      "id": 2,
      "name": "Microempresa Municipal"
    },
    {
      "@id": "/api/special_regimes/3",
      "@type": "SpecialRegime",
      "id": 3,
      "name": "Estimativa"
    },
    {
      "@id": "/api/special_regimes/4",
      "@type": "SpecialRegime",
      "id": 4,
      "name": "Sociedade de Profissionais"
    },
    {
      "@id": "/api/special_regimes/5",
      "@type": "SpecialRegime",
      "id": 5,
      "name": "Cooperativa"
    },
    {
      "@id": "/api/special_regimes/6",
      "@type": "SpecialRegime",
      "id": 6,
      "name": "Microempresário Individual (MEI)"
    },
    {
      "@id": "/api/special_regimes/7",
      "@type": "SpecialRegime",
      "id": 7,
      "name": "Microempresário e Empresa de Pequeno Porte (ME EPP)"
    }
  ]

  tiposTaxRegimeCode = [
    {
      "@id": "/api/tax_regime_codes/1",
      "@type": "TaxRegimeCode",
      "id": 1,
      "name": "Simples Nacional"
    },
    {
      "@id": "/api/tax_regime_codes/2",
      "@type": "TaxRegimeCode",
      "id": 2,
      "name": "Simples Nacional - Excesso Sublimite Receita Bruta"
    },
    {
      "@id": "/api/tax_regime_codes/3",
      "@type": "TaxRegimeCode",
      "id": 3,
      "name": "Regime Normal"
    }
  ]

  occupationAreaList: any[] = [];
  areAllFieldsEmpty(obj: any): boolean {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (obj[key] !== null && obj[key] !== undefined && obj[key] !== '') {
          return false;
        }
      }
    }
    return true;
  }

  closeModal(){
    this.ref.close()
  }
}
